import '../../resources/css/settings/RoleForm.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { Row, Col, Button } from 'react-bootstrap';
import { checkTableAuth } from '../../components/common/access-auth';
import { verifyForm } from '../../components/common/access-form-validation';
import { commonRenderInput, commonRenderSwitch } from '../../components/common/access-form';
import { doGetRoleDetail, doSaveRoleDetail, SAVE_SETTING_ROLE_DETAIL_SUCCESS, SAVE_SETTING_ROLE_DETAIL_FAIL } from '../../actions/settings/index';
// import { verifyNumber } from '../../components/common/access-form-validation';
import { closeModal, popupModalConfirm, openModalAlert, openPickModal, openModalTip } from '../../actions/index';
import RoleAuthList from './RoleAuthList';
import Loading from '../../components/common/Loading';

class RoleForm extends Component {

    submitType = null

    state = {
        popLoading: true
    }
    
    formSubmit = (values, action, props) => {
        const { verifyFormPass, authToken, roleDetail, popupModalConfirm, modalMessage, accountRole, roleTableAuth, doSaveRoleDetail, selectSite, openModalAlert } = this.props;

        if (checkTableAuth('settings', accountRole, roleTableAuth, 2)) {
            if (verifyFormPass) {
                let type;
                switch (modalMessage) {
                    case 'add':
                        type = 'add';
                        break;
                    case 'edit':
                        type = 'edit';
                        break;
                    default:
                        type = null;
                }

                let tableAuthLevels = [];
                roleDetail.auth.forEach(tableInfo => {
                    const objAuthLevel = {
                        roleSeq : roleDetail.seq,
                        tableSeq : tableInfo.seq,
                        authLevel : tableInfo.authLevel
                    };
                    tableAuthLevels.push(objAuthLevel);
                })

                let objBody = {
                    name : values.name,
                    organization : selectSite,
                    description : values.description,
                    flagSuperAdmin : values.flagSuperAdmin === 1,
                    tableAuthLevels: tableAuthLevels
                }; 

                if (type === 'edit') {
                    objBody['seq'] = roleDetail.seq;
                }

                if (type) {
                    popupModalConfirm('Confirm', 'icon-alert', 'Confirm to save?', 300, () => doSaveRoleDetail(authToken, type, objBody), null, false);
                }
            } else {
                openModalAlert("Sorry, field need to fill.");
            }           
            
        } else {
            openModalAlert("Sorry you don't have permission to change config.");
        }
    }

    checkedCheckbox = (fieldName) => {
        const { formValues, change, isReadonly } = this.props;
        if (!isReadonly) {
            const doCheck = formValues[fieldName] !== 1 ? 1 : 0;
            change(fieldName, doCheck);
        }
    }

    loadData = () => {
        const { change, roleDetail } = this.props;
        if (roleDetail) {
            change('name', roleDetail.name);
            change('flagSuperAdmin', roleDetail.flagSuperAdmin ? 1 : 0);
            change('description', roleDetail.description);
        }

        this.setState({
            popLoading: false
        });
    }


    componentDidUpdate (prevProps, prevState, snapshot) {
        const { roleDetail, loading, status, closeModal, errMsg, openModalAlert, openModalTip } = this.props;
    
        if (prevProps.status !== status) {
          // if menu chagne size(mode), need redraw table
          if (status === SAVE_SETTING_ROLE_DETAIL_SUCCESS) {
            openModalTip('Save Role is success.');
            closeModal(null);
          } else if (status === SAVE_SETTING_ROLE_DETAIL_FAIL) {
            if (errMsg) {
                openModalAlert(errMsg);
            }
            console.error("error", SAVE_SETTING_ROLE_DETAIL_FAIL);            
          }
        }

        if (prevProps.roleDetail !== roleDetail) {
            if (roleDetail && !loading) {
                this.loadData();
            }
        }

    }

    componentDidMount() {
        // if call render will do this method
        const { authToken, doGetRoleDetail, selectRole } = this.props;
        if (selectRole) {
            doGetRoleDetail(authToken,  selectRole.seq);
        } else {
            doGetRoleDetail(authToken,  -1);
        }
    }

    render() {
        const { isAdd, closeModal, handleSubmit, modalMessage, isReadonly, verifyFormPass } = this.props;
        const { popLoading } = this.state;

        let cssDisplayEdit;
        // let cssAddHide = '';
        if (isAdd) {
            cssDisplayEdit = '';
            // cssAddHide = 'no-display'
        } else if (modalMessage === 'edit') {
            cssDisplayEdit = '';
        } else {
            cssDisplayEdit = ' no-display';
        }

        return (
            <div className='area-form form-custom'>                               
                <div className='settings-role-form'>
                    <form onSubmit={handleSubmit(this.formSubmit)}>
                        <div className='area-content area-divide-space'>
                            <div className='area-header'>
                                <span className='icon-internet icon-info'></span><label>Role</label>
                            </div>
                            <div className='area-body'>
                                <Row>
                                    <Col sm={6} >
                                        <div className='area-form-label'>
                                            <label className='need-star-label'>*</label><label>Name</label>
                                        </div>
                                        <div className='area-form-field'>
                                            <Field name='name' type="text" component={commonRenderInput} placeholder="Input here" disabled={isReadonly} />
                                        </div>
                                    </Col>
                                    <Col sm={6} >
                                        <div className='area-form-label'>
                                            <label className='need-star-label'></label><label>Super Admin</label>
                                        </div>
                                        <div className='area-form-field'>
                                            <Field name="flagSuperAdmin" component={commonRenderSwitch} customStyle='detail-form-switch detail-form-switch-info' callback={() => this.checkedCheckbox('flagSuperAdmin')}/>
                                        </div>
                                    </Col>
                                    <Col sm={12} >
                                        <div className='area-form-label'>
                                            <label className='need-star-label'></label><label>Description</label>
                                        </div>
                                        <div className='area-form-field'>
                                            <Field name='description' type="text" component={commonRenderInput} placeholder="Input here" disabled={isReadonly} />
                                        </div>
                                    </Col>
                                    
                                </Row>
                            </div>
                        </div>

                        <div className='area-content'>
                            <div className='area-header'>
                                <label>Auth List</label>
                            </div>
                            <div className='area-body'>
                                <RoleAuthList></RoleAuthList>
                            </div>
                        </div>

                        <div className={'area-btns' + cssDisplayEdit }>
                            <Row>
                                <Col sm={4}>
                                    <div className='area-btn-cancel'>
                                        <Button type="button" variant="primary" size="lg" onClick={() => closeModal(null)} block>
                                            <span>Cancel</span>
                                        </Button>
                                    </div>
                                </Col>
                                <Col sm={8}>
                                    <div className='area-btn-save'>
                                        <Button type="submit" variant="primary" size="lg" disabled={!verifyFormPass} block>
                                            <span>Save</span>
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </form>
                </div>
                <Loading loading={popLoading} center={true}></Loading>
            </div>
        )
    }
}

const getverifyField = () => {
    let verifyFields = ['name'];
    return verifyFields
}

const mapStateToProps = (state, ownProps) => {
    const verifyFormPass = verifyForm(state.form['RoleForm'], getverifyField());
    const modalMessage = state.commonReducers.modalMessage;
    const isReadonly = modalMessage === 'view';
    const isAdd = modalMessage === 'add';

    let ret = {
        authToken: state.loginReducers.authToken,
        accountRole: state.loginReducers.accountRole,
        roleTableAuth: state.loginReducers.roleTableAuth,
        loading: state.settingsReducers.loading,
        status: state.settingsReducers.status,
        modalPick: state.commonReducers.modalPick,
        selectRole: state.settingsReducers.selectRole,
        roleDetail: state.settingsReducers.roleDetail,
        errMsg: state.settingsReducers.errMsg,
        selectSite: state.siteReducers.selectSite,
        modalMessage: modalMessage,
        isReadonly: isReadonly,
        isAdd: isAdd,
        initialValues: {},
        verifyFormPass: verifyFormPass,
        formValues: getFormValues('RoleForm')(state)
    }

    return ret;
}

RoleForm = reduxForm({
    form: 'RoleForm',  // a unique identifier for this form
})(RoleForm)

export default connect(
    mapStateToProps,
    { closeModal, popupModalConfirm, openPickModal, doGetRoleDetail, doSaveRoleDetail, openModalAlert, openModalTip }
)(RoleForm)